var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.678,
    height: 181,
    viewBox: "0 0 118.678 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(-4.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2779",
    "data-name": "Rectangle 2779",
    width: 118.678,
    height: 180.999,
    rx: 10,
    transform: "translate(4.075)",
    fill: "#cad9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M214.977,241.948v-29.01H185.948Z",
    transform: "translate(-107.018 -125.297)",
    fill: "#3368da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M63.1,258.534,52.539,247.985,4.075,296.417v21.1l48.465-48.434L63.1,279.632l36.947-36.922L89.486,232.161Z",
    transform: "translate(0 -136.609)",
    fill: "#3368da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M105.973,209.909V180.9H76.944Z",
    transform: "translate(-42.878 -106.445)",
    fill: "#7ca0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M20.871,220.088,10.315,209.539l-6.24,6.235v21.1l6.24-6.236,10.556,10.549,36.947-36.922L47.261,193.715Z",
    transform: "translate(0 -113.986)",
    fill: "#7ca0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M201.384,377.279v-29.01H172.354Z",
    transform: "translate(-99.019 -204.929)",
    fill: "#394277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M125.678,396.508H146.79l19.723-19.71-10.556-10.549Z",
    transform: "translate(-71.554 -215.508)",
    fill: "#394277"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.a593dc7ce263bb104b70783230b7ac0f.svg";
export { ForwardRef as ReactComponent };